
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}},[_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z"}}),_c('circle',{attrs:{"cx":"12","cy":"12","r":"12","fill":"#000","opacity":".7"}}),_c('path',{attrs:{"d":"M17.157 6.843a1.996 1.996 0 0 1 0 2.829l-7.364 7.363a2.5 2.5 0 0 1-1.541.722l-2.21.201.2-2.21a2.5 2.5 0 0 1 .723-1.541l7.363-7.364a1.999 1.999 0 0 1 2.829 0z","stroke":"#FFF"}}),_c('path',{attrs:{"fill":"#FFF","d":"M13.621 6.843l3.536 3.536-.707.707-3.536-3.536z"}})])])
      }
    
      }
    